<template>
  <div class="dev-list">
    <!-- 返回按钮 -->
    <div class="back-button-container">
      <div class="back-button" @click="goBackToGroupList">
        <i class="el-icon-arrow-left"></i>
        <span>返回分组</span>
      </div>
    </div>
    <template>
      <device-window-mobile :id="deviceWindowShowMode.id" :ref="'ref' + deviceWindowShowMode.id"
        :key="deviceWindowShowMode.id" :remark="deviceWindowShowMode.remark"
        :engineType="deviceWindowShowMode.engineType" :device-id="deviceWindowShowMode.deviceNo"
        :ip="deviceWindowShowMode.ip" v-show="deviceWindowShowMode.show"
        @close="deviceWindowClose(deviceWindowShowMode)"></device-window-mobile>
    </template>
    <div class="preview-main" style="margin-top: 50px;margin-bottom: 50px;">
      <template>
        <div v-for="(item, index) in info.list" :key="item.id" class="snapshot-main" :style="{
          'margin-top': '20px',
          'margin-bottom': '10px',
          border:
            checkLicenseService(10) !== -1 ||
              checkLicenseService(11) !== -1 ||
              checkLicenseService(12) !== -1
              ? item.isContainer === 1
                ? '1px solid #409eff'
                : '1px solid red'
              : '1px solid #f6f6f6'
        }">

          <div class="snapshot-main-img" style="position: relative;">
            <div class="dev_buttons" @click="
              deviceWindowOpen(
                item.id,
                item.deviceNo,
                item.deviceIp,
                item.remark,
                item.engineType
              )
              ">
            </div>
            <el-popover placement="right" :disabled="true" v-model="popover[item.deviceIp]">
              <el-image slot="reference"
                :disabled="item.deviceMirrorOperationStatus != null && item.deviceMirrorOperationStatus != 5 && item.deviceMirrorOperationStatus != 14"
                @click="
                  deviceWindowOpen(
                    item.id,
                    item.deviceNo,
                    item.deviceIp,
                    item.remark,
                    item.engineType
                  )
                  " v-loading="snapshotImgLoading[item.deviceIp]" element-loading-background="rgba(0, 0, 0, 0.1)"
                :style="{ width: imgWidth + 'px' }" :src="statusImg(item) ||
                  snapshotImg[item.deviceIp] ||
                  ''
                  " style="display: block" fit="cover"></el-image>

            </el-popover>

          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { commonData } from '@/mixin'
import DeviceWindowMobile from "@/components/DeviceWindowMobile.vue";
export default {
  name: "MobileGroupDeviceList",
  components: {
    DeviceWindowMobile
  },
  inject: ['reload'],
  data() {
    return {
      snapFail: require("../assets/snapfail.png"),
      snapNotUpdate: require("../assets/notupdate.png"),
      snapError: require("../assets/snaperror.png"),
      snapRestart: require("../assets/snaprestart.png"),
      snapShutdown: require("../assets/snapshutdown_cn.png"),
      snapshotImg: {},
      snapshotImgLoading: {},
      deviceWindowShowMode: {
        show: false
      },
      deviceWindowChecks: [],
      snapshotSuccess: false,
      popover: {},
      groupInfo: {
        groupId: "",
        deviceIp: ""
      },
      timeoutId: 0,
      imgWidth: 320,
      snapshotTime: 30,
      // snapshotAutoId: null,
      sortKey: 0,
    };
  },
  mixins: [commonData],

  watch: {
    snapshotTime(n) {
      this.$store.commit(this.$mutation.REFRESH_TIME, n);
      this.snapshotAuto();
    },

    sortKey() {
      this.$store.commit(this.$mutation.SORT_MODE, this.sortKey);
      this.info.list.sort((d1, d2) => {
        if (this.sortKey === 0) {
          // console.log("d1.deviceIp " + d1.deviceIp + ", d2.deviceIp " + d2.deviceIp)
          if (d1.isContainer === 0 && d2.isContainer === 0) {
            return this.ipToInt(d1.deviceIp) - this.ipToInt(d2.deviceIp);
          }
        } else if (this.sortKey === 1) {
          return d1.id >= d2.id ? 1 : -1;
        } else if (this.sortKey === 2) {
          if (this.checkNum(d1.remark) && this.checkNum(d2.remark)) {
            return Number(d1.remark) - Number(d2.remark);
          } else {
            return d1.remark >= d2.remark ? -1 : 1;
          }
        }
      });
      if (this.sortKey === 0) {
        let listTmp = [];
        this.info.list.forEach(dev => {
          if (dev.isContainer === 0) {
            listTmp.push(dev);
            this.info.list.forEach(item => {
              if (item.isContainer === 1 && item.hostIp == dev.deviceIp) {
                listTmp.push(item);
              }
            });
          }
        });
        this.info.list = JSON.parse(JSON.stringify(listTmp));
      }
    }
  },
  methods: {
    checkLicenseService(index) {
      let found = -1;
      if (this.$store.state.licenseInfo && this.$store.state.licenseInfo.service) {
        let serviceItems = this.$store.state.licenseInfo.service.toString().split(",");
        for (let item of serviceItems) {
          if (item == index) {
            found = 1;
            break;
          }
        }
      }
      return found;
    },

    ipToInt(ip) {
      var REG = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
      var result = REG.exec(ip);
      if (!result) return -1;
      return (
        parseInt(result[1]) * 0x1000000 +
        parseInt(result[2]) * 0x10000 +
        parseInt(result[3]) * 0x100 +
        parseInt(result[4])
      );
    },

    checkNum(val) {
      var reg = /^[0-9]+.?[0-9]*$/;
      if (reg.test(val)) {
        return true;
      } else {
        return false;
      }
    },


    // snapshotAuto() {
    //   if (this.snapshotAutoId) {
    //     clearInterval(this.snapshotAutoId);
    //   }
    //   // console.log("snapshotAuto")
    //   if (this.snapshotTime > 0) {
    //     this.snapshotAutoId = setInterval(
    //       this.snapshotAll,
    //       this.snapshotTime * 1000
    //     );
    //   }
    // },

    statusImg(device) {
      if (device.hasOwnProperty('onOff') && device.onOff === 2) {
        return this.snapShutdown
      } else {
        return device.deviceStatus === 1
          ? this.snapNotUpdate
          : device.deviceStatus === 3
            ? this.snapError
            : null;
      }
    },

    snapshotAll() {
      // console.log("snapshotAll")
      this.snapshotSuccess = false;
      this.info.list.forEach(d => {
        let ip = d.deviceIp;
        this.$set(this.snapshotImgLoading, ip, true);
        this
          .$post(this.$uri.device.snapshot, { deviceIp: ip, isSave: 0, isRetImg: 1 })
          .then(res => {
            if (res.success) {
              this.$set(this.snapshotImg, ip, res.data);
            }
            this.$set(this.snapshotImgLoading, ip, false);
          });
      });
    },
    sortList(res) {
      res.list.sort((d1, d2) => {
        if (this.sortKey === 0) {
          return this.ipToInt(d1.deviceIp) - this.ipToInt(d2.deviceIp);
        } else if (this.sortKey === 1) {
          return d1.id >= d2.id ? 1 : -1;
        } else if (this.sortKey === 2) {
          if (this.checkNum(d1.remark) && this.checkNum(d2.remark)) {
            return Number(d1.remark) - Number(d2.remark);
          } else {
            return d1.remark >= d2.remark ? -1 : 1;
          }
        }
      });

      if (this.sortKey === 0) {
        let listTmp = [];
        res.list.forEach(dev => {
          if (dev.isContainer === 0) {
            listTmp.push(dev);
            res.list.forEach(item => {
              if (item.isContainer === 1 && item.hostIp == dev.deviceIp) {
                listTmp.push(item);
              }
            });
          }
        });
        res.list = JSON.parse(JSON.stringify(listTmp));
      }
    },

    /* 获取设备列表 */
    getDeviceList() {
      this
        .$post(this.$uri.device.deviceList, {
          groupId: this.$store.state.groupInfo.id,
        })
        .then(res => {
          this.sortList(res)
          this.$set(this, "info", res);
          this.deviceWindowChecks = [];
          // let smallSpace = false
          // console.log("getDeviceList res")
          // console.log(res)
          this.info.list.forEach(v => {
            this.deviceWindowChecks.push(false);
            // this.deviceStatusStr[v.deviceIp] = this.statusStrM(v);

            this
              .$post(this.$uri.device.snapshot, {
                deviceIp: v.deviceIp,
                isSave: 0,
                isRetImg: 1
              })
              .then(res => {
                if (res.success) {
                  this.$set(this.snapshotImg, v.deviceIp, res.data);
                }
              });
          });
        });
    },

    /* 获取设备列表 */
    getDeviceList2Refresh() {
      this
        .$post(this.$uri.device.deviceList, {
          groupId: this.$store.state.groupInfo.id,
        })
        .then(res => {
          this.sortList(res)
          this.$set(this, "info", res);
          this.info.list.forEach(v => {
            res.list.forEach(i => {
              if (v.id === i.id) {
                v.deviceStatus = i.deviceStatus;
                v.isFlow = i.isFlow;
                v.proxyIp = i.proxyIp;
                v.proxyStatus = i.proxyStatus;
              }
              if (
                v.id === i.id &&
                v.deviceStatus === 1 &&
                i.deviceStatus !== 1
              ) {
                setTimeout(() => {
                  this
                    .$post(this.$uri.device.snapshot, {
                      deviceIp: v.deviceIp,
                      isSave: 0,
                      isRetImg: 1
                    })
                    .then(res => {
                      if (res.success) {
                        this.$set(this.snapshotImg, v.deviceIp, res.data);
                      }
                    });
                }, 1000);
              }
            });
          });
          // res.list.forEach(i => {
          //   this.$set(this.deviceStatusStr, i.deviceIp, this.statusStrM(i));
          // });
        });
    },
    // 返回分组列表页面
    goBackToGroupList() {
      this.$router.push('/home/group/mobileList');
    },
    deviceWindowClose(mode) {
      this.deviceWindowShowMode = {
        show: false,
      }
    },
    deviceWindowOpen(id, deviceNo, ip, remark, engineType) {
      this.deviceWindowShowMode = {
        show: false,
        id,
        remark,
        deviceNo,
        ip: ip,
        engineType
      };
      this.$nextTick(() => {
        this.deviceWindowShowMode.show = true
      })
    },
    /* 10s刷新一次数据 */
    refreshDevList() {
      if (this.$route.meta.refresh) {
        // console.log("refreshDevList")
        this.getDeviceList2Refresh();

        this.timeoutId = setTimeout(() => {
          this.refreshDevList();
        }, 5000);
      }
    },

    getLicense() {
      let licenseNew = {}
      this.$post(this.$uri.system.licenseGet).then(res => {
        if (res.success) {
          licenseNew = res.data
          if (licenseNew.hasOwnProperty("isNew") && licenseNew.isNew == 1) {
            if (licenseNew.secondsLeft === 0) {
              this.$store.commit(this.$mutation.IS_NEED_LICENSE, true)
            } else {
              this.$store.commit(this.$mutation.IS_NEED_LICENSE, false)
            }
          } else {
            if (licenseNew.secondsLeft === 0) {
              this.$store.commit(this.$mutation.IS_NEED_LICENSE, true)
            } else {
              this.$store.commit(this.$mutation.IS_NEED_LICENSE, false)
            }
          }
          this.$store.commit(this.$mutation.LICENSE_SAVE, licenseNew)
          this.$store.commit(this.$mutation.ENABLE_PHONE_MODEL)

          this.licenseInfo = JSON.parse(JSON.stringify(licenseNew))
        }
      })
    },
  },

  beforeMount() {
    this.getLicense()
  },
  mounted() {
    // console.log("MobileGroupDeviceList mounted")
    // this.scaleMode = this.$store.state.scaleMode;
    this.sortKey = this.$store.state.sortMode;
    // this.snapshotTime = this.$store.state.refreshTime;
    // console.log(this.snapshotTime)
    // this.getDeviceType();
    this.getDeviceList();
    // this.refreshDevList();
    // this.snapshotAuto();
    // this.getAllDeviceList();
  },
  beforeDestroy() {
    clearTimeout(this.timeoutId);
    // clearInterval(this.snapshotAutoId);
  }
};
</script>

<style lang="less" scoped>
.dev-list {
  padding-bottom: 20px;

  /* 返回按钮容器 */
  .back-button-container {
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 1000;

    .back-button {
      display: flex;
      align-items: center;
      padding: 8px 12px;
      background-color: #409eff;
      color: white;
      border-radius: 20px;
      font-size: 14px;
      cursor: pointer;
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
      transition: all 0.3s ease;

      i {
        margin-right: 5px;
        font-size: 16px;
      }

      &:hover {
        background-color: #66b1ff;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
      }

      &:active {
        transform: translateY(0);
        box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
      }
    }
  }

  .preview-main {
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    align-items: center;

    .snapshot-main {
      background-color: #f6f6f6;
      border-radius: 0px;

      .snapshot-main-head {
        padding: 0 5px;
        width: 100%;
      }
    }

    #snapshot-main :hover {
      border: 1px solid #409eff;
      border-radius: 6px;
    }
  }

  .preview-main :after {
    content: "";
  }

  .preview-main::-webkit-scrollbar {
    display: none;
  }
}
</style>
